'use client';

import { useState } from 'react';
import Image from 'next/image';
import { PhotoIcon } from '@heroicons/react/20/solid';

import { CircularLoader } from '../../loaders';

interface IPreviewImageFullProps {
  /**
   * The url segment that resolved the image file.
   */
  url: string;
}

/**
 * -----------------------------------------------------------------------------
 * This shows a large preview of an image loaded from the path provided.
 * TODO: Move the image preview component to a separate/images folder.
 */
export function PreviewImageFull({ url }: IPreviewImageFullProps) {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const handleOnLoadImage = () => {
    setIsImageLoaded(true);
  };

  return (
    <div
      className="
        flex h-full w-full flex-1 flex-col items-center justify-center
        overflow-hidden rounded-xl
      "
    >
      {!isImageLoaded ? (
        <>
          <PhotoIcon className="absolute h-16 w-16 text-gray-200" />
          <CircularLoader className="absolute h-8 w-8 text-gray-200 opacity-20" />
        </>
      ) : null}

      <Image
        alt=""
        className="z-[1] h-full w-full rounded-lg object-scale-down"
        height={1200}
        onLoad={handleOnLoadImage}
        src={url}
        width={1200}
      />
    </div>
  );
}
